import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { QualifiedEnquiryFormComponent } from '../../features/qualified-enquiry-form/qualified-enquiry-form.component';

@Component({
  selector: 'wil-landing-enquiry',
  standalone: true,
  imports: [QualifiedEnquiryFormComponent],
  templateUrl: './landing-enquiry.component.html',
  styleUrl: './landing-enquiry.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class LandingEnquiryComponent {}
